// extracted by mini-css-extract-plugin
export default {"paper":"Login_paper__ptZil","buttonText":"Login_buttonText__gHNcz"};